import type { FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'

import { CatalogProductsData } from '@/entities/catalog-old'

import { PERSONAL_API } from '@/shared/lib/utils/constants/const'
import { ServerResponse } from '@/shared/types/common'

import { getCatalogReviewCodes, mapCatalogProductsWithReviews } from './catalog-review-mapper'

export interface GetProductReqProps {
	params: Record<string, string>
	filterUrl: string
	regionCookies?: string
	requestCookies?: string
	merge?: boolean
}

type CatalogBaseQueryResult = { data?: unknown; error?: FetchBaseQueryError }
type CatalogBaseQuery = (args: string | FetchArgs) => CatalogBaseQueryResult | PromiseLike<CatalogBaseQueryResult>

export const fetchCatalogProductsWithReviews = async (
	{ params, filterUrl, regionCookies = '', requestCookies }: GetProductReqProps,
	baseQuery: CatalogBaseQuery
) => {
	const productsResponse = await baseQuery({
		url: `index/catalog/products`,
		params: {
			filter: filterUrl,
			...params
		},
		headers: {
			Cookie: requestCookies || regionCookies
		}
	})

	if (productsResponse.error) return { error: productsResponse.error }

	const productsData = (productsResponse.data as ServerResponse<CatalogProductsData>).data
	const productCodes = getCatalogReviewCodes(productsData.ITEMS)

	if (!productCodes.length) return { data: productsData }

	const reviewsResponse = await baseQuery({
		url: `${PERSONAL_API}/v1/reviews`,
		params: {
			filter: JSON.stringify({ param: { code: productCodes } })
		}
	})

	return {
		data: reviewsResponse.error ? productsData : mapCatalogProductsWithReviews(productsData, reviewsResponse.data)
	}
}
